import inspectableError from 'rlink-inspectable-error';
import {ROW, UNRATED} from 'rlink-regions/constants';

export default class Region {
  constructor (skuGroup = ROW, ratingsBoard = UNRATED, regionRestrictions = '') {
    this.skuGroup = skuGroup;
    this.ratingsBoard = ratingsBoard;
    this.regionRestrictions = regionRestrictions;
  }

  static fromString (constructFrom) {
    let parts = constructFrom.split('-');
    if (parts.length < 1) {
      throw inspectableError`You are trying to construct a region from an invalid string. You tried to use ${constructFrom}. You need to use [skuGroup]-(ratingsBoard)-(regionRestrictions). Where ratingsBoard and regionRestrictions are optional.`;
    }

    return new Region(parts[0], parts[1], parts[2]);
  }

  toString () {
    return `${this.skuGroup}-${(this.ratingsBoard)}${(this.regionRestrictions)
      ? `-${this.regionRestrictions}`
      : ''}`;
  }

}



// WEBPACK FOOTER //
// ./lib/rlink-regions/Region.js